<template>
	<div class="popover" :class="popoverClasses">
		<div class="overlay" @click.prevent="close"></div>
		<form class="popover-content" :style="{top:top, left:left}" action="#" method="get" @submit.prevent="submittedForm" autocomplete="off">
			<slot />
			<div class="buttons" v-if="okButtonName">
				<button @click.prevent="clickedCancelButton">Cancel</button>
				<button @click.prevent="clickedOKButton">{{ okButtonName }}</button>
			</div>
		</form>
	</div>
</template>


<script>
	export default {
		name: 'popover',
		props: {
			okButtonName: String,
			className: String,
			isError: Boolean
		},
		data() {
			return {
				isActive: false,
				isVisible: false,
				top: '0',
				left: '0',
				modal: false
			}
		},
		computed: {
			popoverClasses() {
				let classes = { active: this.isActive, visible: this.isVisible, modal:this.modal, 'error':this.isError }

				if (this.className) {
					classes[this.className] = true
				}

				return classes
			}
		},
		methods: {
			showFromElement(elementOrId) {

				if (this.isActive) {
					return
				}

				this.isActive = true;

				this.$store.commit('setShouldHideFlamingo', true)

				let elm = (typeof elementOrId === 'string') ? document.getElementById(elementOrId) : elementOrId

				this.$nextTick(() => {
					const contentElement = this.$el.querySelector('.popover-content')

					if (elm) {
						const domRect = elm.getBoundingClientRect()
						let top = domRect.top - contentElement.offsetHeight
						let left = domRect.left - ((contentElement.offsetWidth - domRect.width) / 2)

						top = Math.max(top, 10)
						left = Math.max(left, 10)

						this.top = `${ top }px`
						this.left = `${ left }px`
						this.modal = false
					} else {
						this.modal = true
						this.top = '40%'
						this.left = '50%'
					}

					setTimeout(() => {
						this.isVisible = true
						let firstTextField = this.$el.querySelector('input[type=text]')
						firstTextField && firstTextField.focus()
					}, 50)
				})
			},
			clickedCancelButton() {
				this.close()
				this.$emit('clicked-cancel')
			},
			clickedOKButton() {
				this.close()
				this.$emit('clicked-ok')
			},
			submittedForm() {
				this.clickedOKButton()
			},
			close() {
				this.isVisible = false
				setTimeout(() => {this.isActive = false}, 800)
				this.$store.commit('setShouldHideFlamingo', false)
			}
		}
	}
</script>


<style lang="scss">

	.popover {
		width: 0;
		height: 0;

		.overlay {
			display: none;
			position: fixed;
			z-index: 102;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			background-color: #fff;
			opacity: 0.0001;
			transition: opacity 0.8s;
		}

		.popover-content {
			display: none;
			position: fixed;
			left: 0;
			top: 0;
			min-width: 200px;
			z-index: 103;
			background: #fff;
			opacity: 0.0001;
			transform: translateY(10px);
			transition: opacity 0.3s, transform 0.3s;
			padding: 20px 20px 54px 20px;
			box-shadow: 0 1px 8px rgba(0, 0, 0, 0.7);
			border-radius: 10px;
			color: $body-text-color;
			font-size: 16px;

			h1, h2 {
				font-size: 22px;
				margin: 0 0 18px 0;
				padding: 0;
				color: #dedede;

				&:first-child {
					margin-top: -4px;
				}
			}

			.buttons {
				position: absolute;
				right: 20px;
				bottom: 16px;

				& > button {
					display: inline-block;
					margin-left: 10px;
					padding: 2px 16px 3px 16px;
					background: $page-border-color;
					color: #000;
					border: 2px solid #999999;
					border-radius: 14px;
					font-weight: bold;
					font-size: 11px;
					cursor: pointer;
					transition: background-color 0.25s;

					&:hover {
						background-color: #c5c5b2;
					}
				}
			}
		}

		&.error {
			.overlay {
				background: url('/img/just-keep-swimming.jpg');
				background-size: cover;
				background-repeat: no-repeat;
				background-position: center center;
			}

			&.active .overlay {
				opacity: 0.95;
			}
		}

		&.modal .popover-content {
			transform: translate(-50%, calc(-50% + 10px));
		}

		&.active {
			.overlay {
				display: block;
			}

			.popover-content {
				display: block;
			}
		}

		&.visible {
			.overlay {
				opacity: 0.7;
			}

			.popover-content {
				transform: translateY(0);
				opacity: 1.0;
			}

			&.modal .popover-content {
				transform: translate(-50%, -50%);
			}
		}

		label {
			margin-right: 10px;
		}

		input[type=text] {
			width: 200px;
		}
	}
	
</style>
